import { render, staticRenderFns } from "./addSysDict.vue?vue&type=template&id=5cbfb75a&"
import script from "./addSysDict.vue?vue&type=script&lang=js&"
export * from "./addSysDict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports